import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export const ReferralHandler = () => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const referralCode = searchParams.get('ref');
    
    if (referralCode) {
      // Guardar el código de referido en localStorage para usarlo después del registro
      localStorage.setItem('referralCode', referralCode);
      
      // También podemos trackear la visita inicial aquí si es necesario
      const trackInitialVisit = async () => {
        try {
          await supabase
            .from('referral_tracking')
            .insert([
              {
                referral_code: referralCode,
                status: 'pending'
              }
            ]);
        } catch (error) {
          console.error('Error tracking initial visit:', error);
        }
      };
      
      trackInitialVisit();
    }
  }, [searchParams]);

  return null; // Este componente no renderiza nada
};

export default ReferralHandler;
